
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.586 10.828l5.657-5.656-1.415-1.415-5.656 5.657 1.414 1.414zm0 0l-.54.54.54-.54zm-.79.624l-1.248-1.247-.624 1.87 1.871-.623zm7.154-6.988l.707-.707-1.414-1.414-.707.707 1.414 1.414zm0 0l-.707.708.707-.708zM12.243.93l2.828 2.828-8.485 8.486-4.243 1.414 1.414-4.243L12.243.93z"}})])
          )
        }
      }
    